import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDifferenceIgnored: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="difference-ignored"><path fillRule="evenodd" clipRule="evenodd" d="M20.25 3C20.6642 3 21 3.33579 21 3.75V20.25C21 20.6642 20.6642 21 20.25 21H3.75C3.33579 21 3 20.6642 3 20.25V3.75C3 3.33579 3.33579 3 3.75 3H20.25ZM15.7803 8.21973C15.4874 7.92683 15.0126 7.92683 14.7197 8.21973L8.21973 14.7197C7.92683 15.0126 7.92683 15.4874 8.21973 15.7803C8.51262 16.0732 8.98738 16.0732 9.28027 15.7803L15.7803 9.28027C16.0732 8.98738 16.0732 8.51262 15.7803 8.21973Z" fill="currentColor"/></CentralIconBase>;
};

export default IconDifferenceIgnored;
